import type * as Stitches from '@stitches/react';
import { StitchesCSS, styled } from '../../../stitches.config';
import { Card, Icon } from '../../../components';

const Title = styled('h2', {
  marginTop: '$2',
  marginBottom: '$4',
  fontWeight: 500,
});
const Container = styled('div', {
  display: 'flex',
  backgroundColor: '$slate3',
  borderRadius: '$medium',
  position: 'relative',
  fontSize: '$3',
  [`& > ${Icon}`]: {
    fontSize: '$5',
  },
  variants: {
    type: {
      info: {
        [`& > ${Icon}`]: {
          color: '$indigo9',
        },
      },
      warning: {
        [`& > ${Icon}`]: {
          color: '$orange9',
        },
      },
      error: {
        [`& > ${Icon}`]: {
          color: '$red9',
        },
      },
    },
    size: {
      regular: {
        gap: '$5',
        padding: '$7',
      },
      small: {
        gap: '$4',
        padding: '$4 $5 $4',
        fontSize: '$2',

        [`& ${Title}`]: {
          fontSize: '$3',
          marginBottom: '$2',
        },
      },
    },
  },
  defaultVariants: {
    type: 'info',
    size: 'regular',
  },
});

type InfoBoxProps = Stitches.VariantProps<typeof Container> & {
  css?: StitchesCSS;
  icon?: string;
  title?: string;
  children?: React.ReactNode | React.ReactNode[];
};
export const InfoBox = ({ css, icon, title, children, ...variants }: InfoBoxProps) => (
  <Container {...variants} css={css}>
    {icon && <Icon icon={icon} />}
    <div>
      {title && <Title {...variants}>{title}</Title>}
      {children}
    </div>
  </Container>
);
